/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_Prompt_PlaceholderInputs */

const en_landing_studio_prompt_placeholder = /** @type {(inputs: Landing_Studio_Prompt_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Describe your idea. Put any words that must appear in "quotes".`)
};

const zh_landing_studio_prompt_placeholder = /** @type {(inputs: Landing_Studio_Prompt_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`描述你的想法。需要出现在画面中的文字请放进 "引号"。`)
};

/**
* | output |
* | --- |
* | "Describe your idea. Put any words that must appear in \"quotes\"." |
*
* @param {Landing_Studio_Prompt_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_prompt_placeholder = /** @type {((inputs?: Landing_Studio_Prompt_PlaceholderInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_Prompt_PlaceholderInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_prompt_placeholder(inputs)
	return zh_landing_studio_prompt_placeholder(inputs)
});
export { landing_studio_prompt_placeholder as "landing.studio.prompt_placeholder" }